export const msalConfig = {
    auth: {
        clientId: 'd05fd26d-82f0-4741-9fbd-8acbc65f18de',
        authority:
            "https://login.microsoftonline.com/a56222e7-2ad0-4357-81fc-8485f79f59ec",
        redirectUri: process.env.REACT_APP_REDIRECT
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me",
};

